
import {
  Vue, Component,
} from 'vue-property-decorator';
import AttachmentsList from '@/components/AttachmentsList.vue';
import {
  Lead, LeadStatus, PermissionCode, User,
} from '@/types';

@Component({
  components: {
    AttachmentsList,
  },
})
export default class LeadAttachments extends Vue {
  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get status(): LeadStatus {
    return this.lead?.status;
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get userPermissions(): PermissionCode[] {
    return this.$store.getters.currentUserPermissions;
  }

  get isEditable(): boolean {
    if (!['new', 'open'].includes(this.status)) return false;

    // Recupera il TaskCm se esiste
    const taskCm = this.lead.Tasks.find((lt) => lt.name === 'Cm') ?? null;
    const taskCmStatus = taskCm?.status ?? null;

    // Se il Task Cm è presente...
    if (taskCm !== null) {
      if (taskCmStatus === 'completed') {
        // Se il Task Cm è completo, consente le modifiche soltanto
        // se l'utente ha il permesso specifico.
        return this.hasPermission('attachments.altri.add_on_cm');
      }

      // Consente le modifiche se il Task Cm è incompleto
      return taskCmStatus === null;
    }

    // Il Task Cm non è presente,
    // consente le modifiche se lo stato della lead è Nuovo/In Lavorazione
    return true;
  }

  get isDeletable(): boolean {
    return ['new', 'open'].includes(this.status);
  }

  get isChildLead(): boolean {
    return ['installatore-figlia', 'elettrica-figlia', 'termica-figlia'].includes(this.lead?.type);
  }

  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }
}
